import type { FormStepConfig } from '@/configs/docs-form'
import type { DocsFormValues } from '@/helpers/docs-form'
import { SectionCard } from './SectionCard'

type DocsFormReviewSectionsProps = {
  stepConfigs: readonly (readonly FormStepConfig[])[]
  values: DocsFormValues
  onEditStep: (stepIndex: number) => void
}

const formatFieldValue = (value: string) => {
  const trimmedValue = value.trim()
  return trimmedValue.length > 0 ? trimmedValue : 'Не заполнено'
}

export const DocsFormReviewSections = ({
  stepConfigs,
  values,
  onEditStep,
}: DocsFormReviewSectionsProps) =>
  stepConfigs.map((stepSections, stepIndex) =>
    stepSections.map((section) => (
      <SectionCard
        key={section.title}
        title={section.title}
        footer={
          <button
            type="button"
            className="rounded-full w-full px-3 py-2 text-sm font-medium text-[var(--app-accent)] transition hover:bg-[var(--app-accent-soft)]"
            onClick={() => onEditStep(stepIndex)}
          >
            Изменить раздел
          </button>
        }
      >
        {section.fields.map((field) => (
          <div
            key={field.key}
            className="rounded-[22px] border border-[var(--app-border)] bg-[var(--app-input)] px-4 py-3"
          >
            <p className="text-xs font-medium uppercase tracking-[0.12em] text-[var(--app-muted)]">
              {field.label}
            </p>
            <p className="mt-2 whitespace-pre-wrap text-sm leading-6 text-[var(--app-text)]">
              {formatFieldValue(values[field.key])}
            </p>
          </div>
        ))}
      </SectionCard>
    )),
  )
